import { render, staticRenderFns } from "./CGdetails.vue?vue&type=template&id=69f961df&scoped=true"
import script from "./CGdetails.vue?vue&type=script&lang=js"
export * from "./CGdetails.vue?vue&type=script&lang=js"
import style0 from "./CGdetails.vue?vue&type=style&index=0&id=69f961df&prod&scoped=true&lang=scss"
import style1 from "./CGdetails.vue?vue&type=style&index=1&id=69f961df&prod&scoped=true&lang=css"
import style2 from "./CGdetails.vue?vue&type=style&index=2&id=69f961df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f961df",
  null
  
)

export default component.exports